import { DomainView } from "@/components/domain";
import { Badge } from "@/components/ui/badge";
import { useSheetContext } from "@/context/sheet";
import { useDeleteProvider, useGetProvider } from "@/hooks/providers";
import { T } from "@/i18n";
import { formatPhoneNumber } from "@/lib/utils";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { format } from "date-fns";
import { Key } from "react";

export const Route = createFileRoute("/(providers)/providers/_sheet/$id/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { data, isLoading } = useGetProvider(id);
  const { close } = useSheetContext();
  const navigate = useNavigate();
  const { mutate: deleteProvider } = useDeleteProvider({
    onSuccess: () => {
      close(() => {
        navigate({ to: "/providers" });
      });
    },
  });

  return (
    <DomainView
      domain="providers"
      editLink={(children, key) => (
        <Link to="/providers/$id/edit" params={{ id }} key={key as Key}>
          {children}
        </Link>
      )}
      isLoading={isLoading}
      title={data?.name}
      onDelete={() => deleteProvider(id)}
      propsList={[
        {
          title: "providers.fields.email",
          value: data?.email ?? "-",
        },
        {
          title: "providers.fields.phone",
          value: formatPhoneNumber(data?.phone),
        },
        {
          title: "providers.fields.birthdate",
          value: data?.birthdate
            ? format(new Date(data.birthdate), "PPP")
            : "-",
        },
        {
          title: "providers.fields.country",
          value: data?.country ? <T tKey={`countries.${data.country}`} /> : "-",
        },
        {
          title: "providers.fields.language",
          value: data?.language?.length ? (
            <div className="flex items-center gap-1">
              {data.language?.map((l) => <Badge key={l}>{l}</Badge>)}
            </div>
          ) : (
            "-"
          ),
        },
        {
          title: "providers.fields.paymentAfterInvoice",
          value: <T tKey={`common.boolean.${!!data?.paymentAfterInvoice}`} />,
        },
      ]}
    />
  );
}
